export const regionData = [
  {
    key: "Eastern Canada",
    value: "Eastern Canada",
  },
  {
    key: "Western Canada",
    value: "Western Canada",
  },
  {
    key: "Mid-America",
    value: "Mid-America",
  },
  {
    key: "Southern USA",
    value: "Southern USA",
  },
  {
    key: "Western USA",
    value: "Western USA",
  },
  {
    key: "Mid-Atlantic",
    value: "Mid-Atlantic",
  },
  {
    key: "New England",
    value: "New England",
  },
];

// A person's own region (parent and adjudicator accounts): the North American
// regions above plus the CLRG regions elsewhere, as the Teachers' Directory
// (Liosta Oifigiúil) groups them. Events and default syllabi keep regionData.
// A country-then-region picker for parents and organisers is MC2 card d598d339.
export const otherRegions = [
  { key: "Connacht", value: "Connacht", country: "Ireland" },
  { key: "Leinster", value: "Leinster", country: "Ireland" },
  { key: "Munster", value: "Munster", country: "Ireland" },
  { key: "Ulster", value: "Ulster", country: "Ireland" },
  { key: "Scotland", value: "Scotland", country: "Scotland" },
  { key: "Wales", value: "Wales", country: "Wales" },
  { key: "Midlands", value: "Midlands", country: "England" },
  { key: "North East", value: "North East", country: "England" },
  { key: "North West", value: "North West", country: "England" },
  { key: "Southern England", value: "Southern England", country: "England" },
  { key: "Australian Capital Territory", value: "Australian Capital Territory", country: "Australia" },
  { key: "New South Wales", value: "New South Wales", country: "Australia" },
  { key: "Northern Territory", value: "Northern Territory", country: "Australia" },
  { key: "Queensland", value: "Queensland", country: "Australia" },
  { key: "South Australia", value: "South Australia", country: "Australia" },
  { key: "Tasmania", value: "Tasmania", country: "Australia" },
  { key: "Victoria", value: "Victoria", country: "Australia" },
  { key: "Western Australia", value: "Western Australia", country: "Australia" },
  { key: "New Zealand", value: "New Zealand", country: "New Zealand" },
  { key: "Mainland Europe", value: "Mainland Europe", country: "Mainland Europe" },
  { key: "Asia", value: "Asia", country: "Asia" },
  { key: "Middle East", value: "Middle East", country: "Middle East" },
  { key: "Russia", value: "Russia", country: "Russia" },
  { key: "South Africa", value: "South Africa", country: "South Africa" },
  { key: "South America", value: "South America", country: "South America" },
];
export const accountRegions = [...regionData, ...otherRegions];

export const agesCode = [
  {
    key: '5',
    value: ['U5'],
  },
  {
    key: '6',
    value: ['U6'],
  },
  {
    key: '7',
    value: ['U7'],
  },
  {
    key: '8',
    value: ['U8'],
  },
  {
    key: '9',
    value: ['U9'],
  },
  {
    key: '10',
    value: ['U10'],
  },
  {
    key: '11',
    value: ['U11'],
  },
  {
    key: '12',
    value: ['U12'],
  },
  {
    key: '13',
    value: ['U13'],
  },
  {
    key: '14',
    value: ['U14'],
  },
  {
    key: '15',
    value: ['U15'],
  },
  {
    key: '16',
    value: ['U16'],
  },
  {
    key: '17',
    value: ['U17'],
  },
  {
    key: '18',
    value: ['U18'],
  },
  {
    key: '19',
    value: ['U19'],
  },
  {
    key: '20',
    value: ['U20', '19 AND OVER'],
  },
  {
    key: '21',
    value: ['U21', '19 AND OVER', '20 AND OVER'],
  },
  {
    key: '22',
    value: ['U22', '19 AND OVER', '20 AND OVER', '21 AND OVER'],
  },
  {
    key: '23',
    value: ['22 AND OVER', '19 AND OVER', '20 AND OVER', '21 AND OVER'],
  },
];
export const levelsArray = [
  "ALL",
  "BEGINNER",
  "ADVANCED BEGINNER",
  "NOVICE",
  "PRIZEWINNER",
  "PRELIMINARY CHAMPIONSHIPS",
  "OPEN CHAMPIONSHIPS",
  "TEAMS",
  "ARTS AND CULTURE",
  "Non-Level"
];